import SbService from '@/api/SbService.js'
import Vue from 'vue'
export const sb2Module = {
  namespaced: true,
  state: () => ({
    sb2Data: [],
    sb2LoadStatus: 'request',
    paginationSb2StateParams: {
      count: 0,
      limit: 1000,
      total: 0,
      page: 0
    }
  }),

  getters: {
    numPages: (state) =>
      Math.ceil(
        state.paginationSb2StateParams.total /
        state.paginationSb2StateParams.limit
      )
  },
  mutations: {
    get_all(state, data) {
      state.sb2Data = [...data]
    },

    edit_sb2_multiple(state, data) {
      let indexed = state.sb2Data.findIndex(
        (x) => x.secur_clients_ankets__id == data.id
      )
      Object.assign(state.sb2Data[indexed], data.dataEdit)
    },

    delete_data(state, id) {
      let indexed = state.sb2Data.findIndex(
        (x) => x.secur_clients_ankets__id == id
      )
      state.sb2Data.splice(indexed, 1)
    },

    update_pagination(state, { total, count, limit, page }) {
      state.paginationSb2StateParams = { total, count, limit, page }
    },

    load_request(state, status) {
      state.sb2LoadStatus = 'request'
    },
    load_success(state) {
      state.sb2LoadStatus = 'success'
    },
    load_error(state) {
      state.sb2LoadStatus = 'error'
    }
  },
  actions: {
    getSb2All({ commit }, params) {
      commit('load_request')

      SbService.getSb2All(params)
        .then((data) => {
          commit('update_pagination', data.data.data)
          commit('get_all', data.data.data.rows)
          commit('load_success')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
          commit('load_error')
        })
    },

    editSb2Multiple({ commit }, { id, dataEdit }) {
      SbService.editMultiple(id, dataEdit)
        .then((data) => {
          commit('edit_sb2_multiple', { id, dataEdit })
          Vue.$toast.success('Данные успешно обновлены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    },

    deleteSb2Data({ commit }, id) {
      // commit("load_request");
      SbService.delete(id)
        .then((data) => {
          commit('delete_data', id)
          Vue.$toast.success('Данные успешно удалены')
        })
        .catch((error) => {
          Vue.$toast.error('Ошибка загрузки', { duration: 5000 })
        })
    }
  }
}
